import { render, staticRenderFns } from "./AddGenerarMovmiento.vue?vue&type=template&id=90d067ca&scoped=true&"
import script from "./AddGenerarMovmiento.vue?vue&type=script&lang=ts&"
export * from "./AddGenerarMovmiento.vue?vue&type=script&lang=ts&"
import style0 from "./AddGenerarMovmiento.vue?vue&type=style&index=0&id=90d067ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d067ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('90d067ca', component.options)
    } else {
      api.reload('90d067ca', component.options)
    }
    module.hot.accept("./AddGenerarMovmiento.vue?vue&type=template&id=90d067ca&scoped=true&", function () {
      api.rerender('90d067ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/AddGenerarMovmiento.vue"
export default component.exports